import { Col, Form, Modal } from "react-bootstrap";
// import "./Modal.scss";
import FloatingInput from "../compoment/ui/FloatingInput";
import Loader from "../compoment/ui/Loader";
import Email from "../compoment/icon/Email";
import LogoBlack from './../assets/img/MOSIDA-black.png'
import { FormEvent, useState } from "react";
import { useForm } from "../constants/useForm";
import { toast } from "react-toastify";
import EyeOpen from "../compoment/icon/EyeOpen";

interface SigninModalProps {
  show: boolean;
  onHide: () => void;
  props?: Record<string, unknown>;
  setSuccessModal: React.Dispatch<React.SetStateAction<boolean>>;
  setResetModal: React.Dispatch<React.SetStateAction<boolean>>;
}

const ResetModal: React.FC<SigninModalProps> = ({
  show,
  onHide,
  props,
  setResetModal,
  setSuccessModal
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { values, handleChange } = useForm({
    email: "",
  });

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault(); // Prevent default form submission

    if (isSubmitting) return;

    setIsSubmitting(true);
    try {
      onHide();
      setSuccessModal(true)
      toast.success("Code verified successfully");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {isSubmitting && <Loader />}
      <Modal
        className="mosidaModal signinModal"
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={onHide}
      >
        <Modal.Header className="pb-0" closeButton></Modal.Header>
        <Modal.Body className="py-5">
          <Col md={10} className="mx-auto">
            <div className="text-center mb-4 pb-md-2 mt-5">
              <img
                className="pointer"
                style={{ width: 140 }}
                src={LogoBlack}
                alt=""
              />
            </div>

            <div className="sectionHeading mb-4 pb-3">
              Create new password
            </div>
            <Form onSubmit={handleSubmit}>
              <FloatingInput
                placeholder="Enter password"
                label="Password"
                icon={EyeOpen}
                type="text"
                name="password"
                onChange={handleChange}
              />
              <FloatingInput
                placeholder="Enter confirm password"
                label="Confirm password"
                icon={EyeOpen}
                type="text"
                name="confirm_password"
                onChange={handleChange}
              />
              <button
                className="btnPrimary w-100 sqaure mb-4"
                type="submit"
                disabled={isSubmitting}
              >
                Continue
              </button>
            </Form>

            {/* <div className="dontHaveAccount mt-4">
              {`Don’t have an account?`}{" "}
              <span
                className="text-primary"
                onClick={() => {
                  setForgotPasswordModal(false);
                  setSignupModal(true);
                }}
              >
                Sign up
              </span>
            </div> */}
          </Col>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ResetModal;


